import { createContext, useContext, useMemo } from 'react';

import {
  createFilterStateHook,
  FilterContextValue,
  useFilterApplicationAssignee,
  useFilterApplicationDates,
  useFilterApplicationIntegrationStatus,
  useFilterApplicationJobTitle,
  useFilterApplicationPersonalDetails,
} from 'features/filters';
import { OnboardApplication } from 'types/applications';

export const useOnboardingFilterState = createFilterStateHook();

export const mapKeyToSortKey: Partial<Record<keyof OnboardApplication, string>> = {
  name: 'name',
  date: 'date',
  jobTitle: 'job',
};

export const pageSize = 50;

export const useOnboardingFilterConfig = () => {
  const personalDetails = useFilterApplicationPersonalDetails();
  const assignee = useFilterApplicationAssignee();
  const dates = useFilterApplicationDates();
  const job = useFilterApplicationJobTitle();
  const integrationStatus = useFilterApplicationIntegrationStatus();

  return useMemo(() => {
    return [[personalDetails, job, assignee, dates, integrationStatus]];
  }, [personalDetails, job, assignee, dates, integrationStatus]);
};

const OnboardingContext = createContext({} as FilterContextValue<OnboardApplication>);

export const useOnboardingContext = () => useContext(OnboardingContext);

export const OnboardingProvider: React.FC<FilterContextValue<OnboardApplication>> = ({
  children,
  ...rest
}) => <OnboardingContext.Provider value={{ ...rest }}>{children}</OnboardingContext.Provider>;
